export default __webpack_public_path__ + "2a63e1d8db8eb093ff294d5c87568b44.svg";